require('../../modules/es6.object.assign');
module.exports = require('../../modules/_core').Object.assign;



//////////////////
// WEBPACK FOOTER
// ./~/react-bootstrap/~/core-js/library/fn/object/assign.js
// module id = 319
// module chunks = 0